import { Component, Inject, OnInit } from '@angular/core';
import { forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { FormControl, FormGroup, UntypedFormGroup } from '@angular/forms';
import { DataInput } from '@trivelope/triv-ui-tools-lib';
import { UserSaveError, UserService } from 'src/app/services/user.service';
import { User, UserRoles } from 'src/app/classes/user';
import { Member } from 'src/app/classes/member';
import { Environment } from 'src/app/classes/environment';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { MemberService } from 'src/app/services/member.service';
import { Router } from '@angular/router';
import { CalendarService } from 'src/app/services/calendar.service';
import { NewsService } from 'src/app/services/news.service';
import { Validators } from '@angular/forms';

export interface DialogData {
	members: Member[];
}


@Component({
	selector: 'user-creator',
	templateUrl: './user-creator.component.html',
	styleUrl: './user-creator.component.scss'
})
export class UserCreatorComponent implements OnInit {


	emailCtrl = new FormControl( "", [ Validators.required ] );
	formG1: UntypedFormGroup = new FormGroup({
		ebeMail: this.emailCtrl,
		ebePassword: new FormControl( "" ),
		ebePasswordCheck: new FormControl( "" ),
	});
	myInputs: { [name: string]: DataInput } = {};

	bInProgress = true;
	passwordError = "";

	mainContactCtrl = new FormControl( false );

	bError = false;

	selectedCalendarGroups: string[] = [];
	selectedRubrics: string[] = [];


	constructor(
		private userService: UserService,
		@Inject('environment') public environment: Environment,
		private authenticationService: AuthenticationService,
		private memberService: MemberService,
		private router: Router,
		private calendarService: CalendarService,
		private newsService: NewsService
	) {}


	ngOnInit() {

		const sidenavs = document.getElementsByTagName( "mat-sidenav-content" );
		if( sidenavs && sidenavs.length ) sidenavs[0].scrollTop = 0;

		for( let dataInput of this.environment.user ) {
			this.myInputs[ dataInput.id ] = dataInput;
		}

		this.memberService.getManageableMembers().subscribe( members => {

			this.bInProgress = false;

			this.myInputs[ 'mitgliedId' ].options = [];
			for( const member of members ) {
				(this.myInputs[ 'mitgliedId' ] as any).options.push( {
					id: member.mitgliedId,
					label: member.mitgliedsname
				});
			}

			const user = this.authenticationService.getCurrentUser();
			if( user && user.ebeId && user.gruppen && user.gruppen.includes( UserRoles.MITGLIED_ADMIN ) ) {

				if( members && members.length == 1 ) {

					const ctrl = this.formG1.get( "mitgliedId" );
					if( ctrl ) {

						ctrl.patchValue( {
							id: members[0].mitgliedId,
							label: members[0].mitgliedsname
						} );
						ctrl.setValue( {
							id: members[0].mitgliedId,
							label: members[0].mitgliedsname
						} );

						if( this.myInputs.mitgliedId.options ) {
							const option = this.myInputs.mitgliedId.options.find( (op:{id:string}) =>
								op.id == members[0].mitgliedId
							);
							if( option ) {
								ctrl.setValue( option );
							}
						}

					}

				}
			}

		});

	}


	clickCreate() {

		if( this.formG1.value.ebePassword !== this.formG1.value.ebePasswordCheck ) {
			this.passwordError = "Passwörter müssen identisch sein";
			return;
		}
		this.passwordError = "";

		const user = new User();
		user.ebeId = this.formG1.value.ebeId;
		user.ebeVorname = this.formG1.value.ebeVorname;
		user.ebeName = this.formG1.value.ebeName;
		user.ebePassword = this.formG1.value.ebePassword;
		user.ebePasswordCheck = this.formG1.value.ebePasswordCheck;
		user.ebeMail = this.formG1.value.ebeMail;
		user.mitgliedId = this.formG1.value.mitgliedId.id;

		user.ansStrasse = this.formG1.value.ansStrasse;
		user.ansHausnummer = this.formG1.value.ansHausnummer;
		user.ansOrt = this.formG1.value.ansOrt;
		user.ansPlz = this.formG1.value.ansPlz;
		user.ebeAnrede = this.formG1.value.ebeAnrede?.id || "";
		user.ebeTitel = this.formG1.value.ebeTitel?.id || "";
		user.ebeTelefon = this.formG1.value.ebeTelefon || "";
		user.ebePosition = this.formG1.value.ebePosition || "";

		user.ebeAktiv = this.formG1.value.ebeAktiv ? "ja" : "nein";

		user.gruppen = [ UserRoles.MITGLIED ];
		// user.gruppen = [];
		if( !!this.formG1.value.bAdminMember ) {
			user.gruppen.push( UserRoles.MITGLIED_ADMIN );
		}
		if( !!this.formG1.value.bMaintenanceRights ) {
			user.gruppen.push( UserRoles.MITGLIED_DATENPFLEGE );
		}
		if( !!this.formG1.value.bExportRights ) {
			user.gruppen.push( UserRoles.MITGLIED_DATENEXPORT );
		}


		this.bError = false;
		this.bInProgress = true;

		this.userService.createUser( user ).pipe(
			switchMap( result => {

				if( typeof(result) == "number" ) {

					if( result == UserSaveError.emailAlreadyUsed ) {
						this.emailCtrl.setErrors( { alreadyUsed: true } );
					}
					else if( result == UserSaveError.emailInvalid ) {
						this.emailCtrl.setErrors( { emailInvalid: true } );
					}
					else if( result == UserSaveError.wrongPassword ) {
						this.passwordError = "Bitte geben Sie ein Kennwort ein, welches aus 12 Zeichen, einen Klein- und Großbuchstaben und einer Zahl besteht.";
					}

					return of(false);

				}
				else if( !result.ebeId ) {
					return of(false);
				}


				const additionalSaves: Observable<boolean>[] = [];

				if( this.mainContactCtrl.value ) {
					additionalSaves.push( this.memberService.setMitgliedMainContact( result.ebeId, result.mitgliedId ) );
				}
				if( this.selectedCalendarGroups.length ) {
					additionalSaves.push( this.calendarService.subscribeUserToCalendarGroups( result.ebeId, this.selectedCalendarGroups ) );
				}
				if( this.selectedRubrics.length ) {
					additionalSaves.push( this.newsService.subscribeUserToRubrics( result.ebeId, this.selectedRubrics ) );
				}

				if( !additionalSaves.length ) return of(true);

				return forkJoin( additionalSaves ).pipe(
					map( results => {
						if( !results ) return false;
						for( const b of results ) {
							if( !b ) return false;
						}
						return true;
					})
				);

			} ),
		).subscribe( b => {

			this.bInProgress = false;

			if( b ) this.router.navigate( [ '/Benutzerverwaltung'] );

			this.bError = !b;

		});

	}

}
